<template>
  <b-tooltip
    :label="label"
    type="is-dark"
    dashed
    position="is-bottom"
  >
    <span>
      <i
        class="mdi mdi-18px"
        :class="`mdi-${icon}`"
      />
    </span>
    <b-icon
      :icon="sortIcon"
      both
      size="is-small"
      class="sort-icon"
      :class="{
        'is-desc': sortDirection == 'desc',
        'is-invisible': column.$table.currentSortColumn !== column
      }"
    />
  </b-tooltip>
</template>

<script>
export default {
  props: {
    column: {
      required: true,
      type: Object
    },
    label: {
      required: true,
      type: String
    },
    icon: {
      required: true,
      type: String
    }
  },
  computed: {
    sorted () {
      if (!this.column.$table._props.defaultSort) {
        return false;
      }
      return this.column.$table._props.defaultSort[0] == this.column._props.field;
    },
    sortDirection () {
      if (!this.column.$table._props.defaultSort) {
        return "desc";
      }
      return this.column.$table._props.defaultSort[1];
    },
    sortIcon () {
      return this.column.$table._props.sortIcon;
    }
  }
};
</script>

<style lang="scss" scoped>
.sort-icon {
  transition-duration: 200ms;
  transition-property: transform;

  &.rotated {
    transform: rotate(180deg) !important;
    transform-origin: 50%;
  }
}
</style>
